import { type TFunction } from "i18next";
import { Funnel } from "lucide-react";

import {
  MultiSelectCombobox,
  type ComboboxOption,
} from "../../InfoHub/Components/Form/Components/MultiSelectCombobox";
import { type CommoditiesFilterState } from "./List/components/types";

interface CommoditiesFiltersProps {
  aggregatorOptions: ComboboxOption[];
  areLocationsLoading: boolean;
  areAggregatorsLoading: boolean;
  filters: CommoditiesFilterState;
  locationOptions: ComboboxOption[];
  onChange: (patch: Partial<CommoditiesFilterState>) => void;
  t: TFunction;
}

const selectedOption = (options: ComboboxOption[], value: number | string | null) =>
  value === null ? [] : options.filter(option => option.value === value);

export const CommoditiesFilters = ({
  aggregatorOptions,
  areAggregatorsLoading,
  areLocationsLoading,
  filters,
  locationOptions,
  onChange,
  t,
}: CommoditiesFiltersProps) => (
  <>
    <div className="w-full sm:w-auto sm:max-w-56">
      <MultiSelectCombobox<ComboboxOption>
        id="commodities-filter-aggregator"
        singleSelect
        icon={<Funnel className="size-4" aria-hidden="true" />}
        triggerPrefix={t("filters.aggregatorLabel")}
        options={aggregatorOptions}
        value={selectedOption(aggregatorOptions, filters.aggregatorId)}
        isLoading={areAggregatorsLoading}
        placeholder={t("filters.all")}
        clearLabel={t("filters.clearAggregator")}
        onClear={() => onChange({ aggregatorId: null })}
        onChange={selected => onChange({ aggregatorId: selected[0]?.value ?? null })}
      />
    </div>
    <div className="w-full sm:w-auto sm:max-w-56">
      <MultiSelectCombobox<ComboboxOption>
        id="commodities-filter-location"
        singleSelect
        icon={<Funnel className="size-4" aria-hidden="true" />}
        triggerPrefix={t("filters.locationLabel")}
        options={locationOptions}
        value={selectedOption(locationOptions, filters.administrativeAreaId)}
        isLoading={areLocationsLoading}
        placeholder={t("filters.all")}
        clearLabel={t("filters.clearLocation")}
        onClear={() => onChange({ administrativeAreaId: null })}
        onChange={selected => onChange({ administrativeAreaId: selected[0]?.value ?? null })}
      />
    </div>
  </>
);
